<template>
  <main id="account" class="page-container">
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="errorMessage2"
      :class="{ 'error-message': true, show: errorMessage2 }"
    >
      {{ errorMessage2 }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p>
    <p
      v-if="successMessage2"
      :class="{ 'success-message': true, show: successMessage2 }"
    >
      {{ successMessage2 }}
    </p> -->

    <!-- Form principale -->
    <form class="create-account-form" @submit.prevent="handleSubmit">
      <h3><strong>Cambio Password</strong></h3>
      <!-- RIGA 1: account email, old/new password -->
      <div class="create-account-row row-1">
        <div class="field">
          <label for="account-email1">Email</label>
          <input
            id="account-email1"
            type="email"
            placeholder="Indirizzo email"
            v-model="emailStep1"
            autocomplete="email"
            required
          />
        </div>

        <div class="field" v-if="step === 1">
          <!-- Vecchia Password -->
          <label v-if="step === 1" for="old-password">Vecchia Password</label>
          <div class="account-password-field">
            <input
              v-if="step === 1"
              id="old-password"
              :type="showPassword1 ? 'text' : 'password'"
              placeholder="Inserisci vecchia password"
              v-model="oldPassword"
              autocomplete="current-password"
              required
            />

            <!-- Occhio (o icona) per mostrare/nascondere la password -->
            <button
              type="button"
              class="toggle-password-button"
              @click="togglePassword1"
            >
              <!-- Se showPassword2 è false, mostra icona occhio aperto. Altrimenti, occhio chiuso. -->
              <i v-if="!showPassword1" class="fa-solid fa-eye-slash"></i>
              <i v-else class="fa-solid fa-eye"></i>
            </button>
          </div>
        </div>

        <div class="field" v-if="step === 2">
          <!-- Nuova Password -->
          <label v-if="step === 2" for="account-password1"
            >Nuova Password</label
          >
          <div class="account-password-field">
            <input
              v-if="step === 2"
              id="account-password1"
              :type="showPassword2 ? 'text' : 'password'"
              placeholder="Inserisci nuova password"
              v-model="newPasswordStep2"
              autocomplete="new-password"
              required
            />

            <!-- Occhio (o icona) per mostrare/nascondere la password -->
            <button
              type="button"
              class="toggle-password-button"
              @click="togglePassword2"
            >
              <!-- Se showPassword2 è false, mostra icona occhio aperto. Altrimenti, occhio chiuso. -->
              <i v-if="!showPassword2" class="fa-solid fa-eye-slash"></i>
              <i v-else class="fa-solid fa-eye"></i>
            </button>
          </div>
        </div>

        <div class="save-button-container">
          <button
            type="submit"
            id="change-password"
            :disabled="
              !emailStep1 || (step === 1 ? !oldPassword : !newPasswordStep2)
            "
          >
            {{ step === 1 ? "Verifica vecchia password" : "Aggiorna password" }}
          </button>
        </div>
      </div>
    </form>

    <hr />
    <form class="create-account-form" @submit.prevent="apriConfermaAdmin">
      <h3><strong>Aggiungi admin</strong></h3>
      <!-- RIGA 2: nome operatore, account email -->
      <div class="create-account-row row-2">
        <div class="field">
          <!-- nome operatore, opzionale [sc-48833] -->
          <label for="account-operator-name">Nome operatore</label>
          <input
            id="account-operator-name"
            type="text"
            placeholder="Nome dell'operatore"
            v-model="operatorName"
            autocomplete="off"
            maxlength="255"
          />
          <!-- [sc-48833] avviso, non blocco: due nomi uguali sono leciti -->
          <p v-if="operatoreConStessoNome" class="field-warning">
            Nome già usato da {{ operatoreConStessoNome.email }}.
          </p>
        </div>

        <div class="field">
          <!-- account email -->
          <label for="account-email2">Email</label>
          <input
            id="account-email2"
            type="email"
            placeholder="Indirizzo email"
            v-model="emailAdmin"
            autocomplete="email"
            required
          />
          <!-- [sc-48833] l'email sbagliata si scopre prima del salvataggio -->
          <p v-if="emailAdminErrore" class="field-error">
            {{ emailAdminErrore }}
          </p>
        </div>
      </div>

      <!-- RIGA 3: password e conferma [sc-48833] -->
      <div class="create-account-row row-3">
        <div class="field">
          <!-- password -->
          <label for="get-password">Password</label>
          <div class="account-password-field">
            <input
              id="get-password"
              :type="showAdminPassword ? 'text' : 'password'"
              placeholder="Password"
              v-model="passwordAdmin"
              autocomplete="current-password"
              required
            />

            <!-- Occhio (o icona) per mostrare/nascondere la password -->
            <button
              type="button"
              class="toggle-password-button"
              @click="toggleAdminPassword"
            >
              <!-- Se showAdminPassword è false, mostra icona occhio aperto. Altrimenti, occhio chiuso. -->
              <i v-if="!showAdminPassword" class="fa-solid fa-eye-slash"></i>
              <i v-else class="fa-solid fa-eye"></i>
            </button>
          </div>
        </div>

        <div class="field">
          <!-- conferma password [sc-48833] -->
          <label for="get-password-confirm">Conferma password</label>
          <div class="account-password-field">
            <input
              id="get-password-confirm"
              :type="showAdminPasswordConfirm ? 'text' : 'password'"
              placeholder="Ripeti la password"
              v-model="passwordAdminConfirm"
              autocomplete="new-password"
              required
            />

            <!-- Occhio (o icona) per mostrare/nascondere la password -->
            <button
              type="button"
              class="toggle-password-button"
              @click="toggleAdminPasswordConfirm"
            >
              <i
                v-if="!showAdminPasswordConfirm"
                class="fa-solid fa-eye-slash"
              ></i>
              <i v-else class="fa-solid fa-eye"></i>
            </button>
          </div>
          <p v-if="passwordAdminMismatch" class="field-error">
            Le due password non coincidono.
          </p>
        </div>

        <div class="save-button-container">
          <button id="add-admin" type="submit" :disabled="!datiAdminValidi">
            Aggiungi admin
          </button>
        </div>
      </div>
    </form>

    <hr />
    <!-- Riepilogo degli operatori già presenti [sc-48833] -->
    <section class="operators-summary">
      <h3><strong>Operatori già presenti</strong></h3>

      <p v-if="operatorsError" class="operators-empty">{{ operatorsError }}</p>
      <p v-else-if="loadingOperators" class="operators-empty">Caricamento…</p>
      <p v-else-if="!operators.length" class="operators-empty">
        Nessun operatore da mostrare.
      </p>

      <div v-else class="operators-table-wrap">
        <table class="operators-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Email</th>
              <th>Ruolo</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="op in operators"
              :key="op.id"
              :class="{ archiviato: op.isArchived }"
            >
              <td>{{ op.operatorName || "—" }}</td>
              <td>{{ op.email }}</td>
              <td>
                {{ op.isAdmin ? "Admin" : "Magazziniere" }}
                <span v-if="op.isArchived" class="badge-archiviato"
                  >Archiviato</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="operators-note">
        Un operatore archiviato non accede più al CRM, ma la sua email resta
        occupata: non puoi riusarla per crearne uno nuovo. Archiviare o
        riattivare un operatore non si fa da qui: scrivi a Liberotratto.
      </p>
    </section>

    <!-- [sc-48833] Ultimo passaggio prima della creazione: un admin creato per
         errore non si elimina dal CRM, l'unica difesa è rileggere i dati. -->
    <VueFinalModal
      v-model="showConfermaAdmin"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="showConfermaAdmin = false"
          title="Chiudi"
          type="button"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        <h3 class="modal__title">Confermi i dati del nuovo admin?</h3>
        <p class="modal__subtitle">
          Rileggi l'email: un operatore creato per errore non si elimina dal CRM
          e il suo indirizzo resta occupato.
        </p>

        <dl class="confirm-admin-recap">
          <div class="confirm-admin-row">
            <dt>Nome</dt>
            <dd>{{ nomeAdminAnteprima }}</dd>
          </div>
          <div class="confirm-admin-row">
            <dt>Email</dt>
            <dd class="confirm-admin-email">{{ emailAdminPulita }}</dd>
          </div>
          <div class="confirm-admin-row">
            <dt>Ruolo</dt>
            <dd>Admin (accesso completo al CRM)</dd>
          </div>
        </dl>

        <p v-if="!operatorName.trim()" class="confirm-admin-nota">
          Nome non indicato: viene usata la parte prima della @.
        </p>

        <div class="modal-actions">
          <button
            type="button"
            class="secondary-btn"
            @click="showConfermaAdmin = false"
          >
            Correggi
          </button>
          <button
            type="button"
            class="primary-btn confirm-btn"
            :disabled="creazioneAdminInCorso"
            @click="createNewAdmin"
          >
            {{ creazioneAdminInCorso ? "Creazione…" : "Conferma e crea" }}
          </button>
        </div>
      </template>
    </VueFinalModal>
  </main>
</template>

<script>
import { setAuth } from "../router";

export default {
  data() {
    return {
      operatorName: "",
      step: 1, // Step iniziale
      emailStep1: "",
      oldPassword: "",
      newPasswordStep2: "",
      emailAdmin: "",
      passwordAdmin: "",
      passwordAdminConfirm: "", // [sc-48833] conferma password
      errorMessage: "",
      errorMessage2: "",
      successMessage: "",
      successMessage2: "",
      showPassword1: false, // controlla se la password è visibile
      showPassword2: false,
      showAdminPassword: false,
      showAdminPasswordConfirm: false,
      // [sc-48833] Riepilogo operatori: lista locale, non lo store, così le
      // tendine di scelta (DdtModal) non si ritrovano dentro gli archiviati
      operators: [],
      loadingOperators: false,
      operatorsError: "",
      // [sc-48833] conferma dei dati prima della creazione
      showConfermaAdmin: false,
      creazioneAdminInCorso: false,
    };
  },
  computed: {
    // [sc-48833] La password non si rilegge dopo il salvataggio (è hashata) e
    // l'operatore nuovo la riceve da chi lo crea: un errore di battitura si
    // scopre solo al primo login fallito.
    passwordAdminMismatch() {
      return (
        this.passwordAdminConfirm.length > 0 &&
        this.passwordAdmin !== this.passwordAdminConfirm
      );
    },

    // [sc-48833] Quella che viene salvata: senza trim l'email finirebbe nel DB
    // con lo spazio in coda e il login, che confronta la stringa esatta, non
    // troverebbe più l'operatore.
    emailAdminPulita() {
      return this.emailAdmin.trim();
    },

    // Per i soli confronti: il vincolo univoco di Postgres è sensibile alle
    // maiuscole, l'occhio di chi guarda la tabella no.
    emailAdminNormalizzata() {
      return this.emailAdminPulita.toLowerCase();
    },

    emailAdminFormatoValido() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(this.emailAdminPulita);
    },

    // [sc-48833] L'elenco del riepilogo è già in pagina, archiviati compresi:
    // il doppione si vede subito invece di arrivare come 409 dopo il submit.
    operatoreConStessaEmail() {
      if (!this.emailAdminNormalizzata) return null;

      return (
        this.operators.find(
          (op) =>
            (op.email || "").trim().toLowerCase() ===
            this.emailAdminNormalizzata
        ) || null
      );
    },

    emailAdminErrore() {
      if (!this.emailAdminPulita) return "";
      if (!this.emailAdminFormatoValido) return "Indirizzo email non valido.";

      const operatore = this.operatoreConStessaEmail;
      if (!operatore) return "";

      const chi = operatore.operatorName || operatore.email;

      return operatore.isArchived
        ? `Email già usata dall'operatore archiviato «${chi}»: resta occupata, scegline un'altra.`
        : `Email già usata dall'operatore «${chi}».`;
    },

    // Stessa regola dell'API: senza nome si usa quello che precede la @.
    nomeAdminAnteprima() {
      const scelto = this.operatorName.trim();
      if (scelto) return scelto;

      return this.emailAdminNormalizzata.split("@")[0] || "—";
    },

    // Avviso, non blocco: due operatori omonimi sono leciti, ma nella tabella
    // non si distinguono più.
    operatoreConStessoNome() {
      const nome = this.nomeAdminAnteprima.toLowerCase();
      if (!nome || nome === "—") return null;

      return (
        this.operators.find(
          (op) => (op.operatorName || "").trim().toLowerCase() === nome
        ) || null
      );
    },

    datiAdminValidi() {
      return (
        Boolean(this.emailAdminPulita) &&
        !this.emailAdminErrore &&
        Boolean(this.passwordAdmin) &&
        Boolean(this.passwordAdminConfirm) &&
        !this.passwordAdminMismatch
      );
    },
  },
  mounted() {
    this.fetchOperatorsSummary();
  },
  methods: {
    // [sc-48833] Chi crea un operatore deve vedere le email già usate e come
    // sono scritti i nomi degli altri. Con gli archiviati, la cui email resta
    // occupata anche se non accedono più.
    async fetchOperatorsSummary() {
      this.loadingOperators = true;
      this.operatorsError = "";
      try {
        const { data } = await this.$axios.get("/auth/get-all", {
          params: { includeArchived: true },
        });
        this.operators = Array.isArray(data) ? data : [];
      } catch (error) {
        this.operatorsError =
          error.response?.data?.details ||
          "Impossibile caricare l'elenco degli operatori.";
        console.error("Errore durante il fetch degli operatori: ", error);
      } finally {
        this.loadingOperators = false;
      }
    },
    togglePassword1() {
      // Inverte lo stato showPassword1
      this.showPassword1 = !this.showPassword1;
    },
    togglePassword2() {
      // Inverte lo stato showPassword2
      this.showPassword2 = !this.showPassword2;
    },
    toggleAdminPasswordConfirm() {
      this.showAdminPasswordConfirm = !this.showAdminPasswordConfirm;
    },
    toggleAdminPassword() {
      // Inverte lo stato showAdminPassword
      this.showAdminPassword = !this.showAdminPassword;
    },
    async handleSubmit() {
      if (this.step === 1) {
        // Step 1: Verifica Vecchia Password
        try {
          const payload = {
            email: this.emailStep1,
            password: this.oldPassword,
          };
          const response = await this.$axios.post(
            "/auth/verify-password",
            payload
          );
          // console.log(response);
          if (response.status === 200) {
            this.step = 2; // Passa allo step 2
            this.successMessage =
              "Password verificata! Inserisci la nuova password.";
            this.$toast.success(this.successMessage);
            this.errorMessage = "";
          } else {
            this.errorMessage =
              response.data.details || "Email/password non corretti";
            this.$toast.error(this.errorMessage);
            this.successMessage = "";
          }
        } catch (error) {
          this.errorMessage =
            error.response?.data?.message || "Errore durante la verifica.";
          this.$toast.error(this.errorMessage);
          this.successMessage = "";
          console.error("Errore durante la verifica password:", error);
        }
      } else if (this.step === 2) {
        // Step 2: Aggiorna Nuova Password
        try {
          const payload = {
            email: this.emailStep1,
            password: this.newPasswordStep2,
          };
          const response = await this.$axios.patch(
            "/auth/change-password",
            payload
          );
          if (response.status === 200) {
            this.step = 1;
            this.successMessage2 =
              response.data.details || "Password aggiornata con successo!";
            this.$toast.success(this.successMessage2);
            this.emailStep1 = "";
            this.emailAdmin = "";
            this.errorMessage2 = "";
            this.oldPassword = "";
            this.newPasswordStep2 = "";

            setTimeout(() => {
              setAuth(false); // logout
              // push alla login page dopo 2 secondi
              this.$router.push("/login");
              this.$toast.info("Effettua il login con la nuova password.");
            }, 2000);
          } else {
            this.errorMessage2 =
              response.data.details || "Password già aggiornata alla modifica";
            this.$toast.error(this.errorMessage2);
            this.successMessage2 = "";
          }
        } catch (error) {
          this.errorMessage2 =
            error.response?.data?.message || "Errore durante l'aggiornamento.";
          this.$toast.error(this.errorMessage2);
          this.successMessage2 = "";
          console.error("Errore durante l'aggiornamento password:", error);
        }
      }
    },
    // [sc-48833] Il submit non crea più niente: apre il riepilogo. Il typo in
    // un'email valida e non duplicata lo prende solo chi rilegge.
    apriConfermaAdmin() {
      this.errorMessage = "";
      this.successMessage = "";

      if (!this.datiAdminValidi) {
        // Col tasto Invio il form parte anche a bottone disabilitato
        this.errorMessage =
          this.emailAdminErrore ||
          (this.passwordAdminMismatch
            ? "Le due password non coincidono."
            : "Compila email e password.");
        this.$toast.error(this.errorMessage);
        return;
      }

      this.showConfermaAdmin = true;
    },

    async createNewAdmin() {
      this.errorMessage = "";
      this.successMessage = "";

      // [sc-48833] Guardia anche qui: col tasto Invio il form parte comunque
      if (this.passwordAdmin !== this.passwordAdminConfirm) {
        this.errorMessage = "Le due password non coincidono.";
        this.$toast.error(this.errorMessage);
        return;
      }

      this.creazioneAdminInCorso = true;

      try {
        const payload = {
          // [sc-48833] Nome opzionale: se vuoto l'API usa il prefisso dell'email
          operatorName: this.operatorName.trim(),
          email: this.emailAdminPulita,
          password: this.passwordAdmin,
        };
        const response = await this.$axios.post("/auth/create-admin", payload);
        if (response.status === 200) {
          this.successMessage =
            response.data.message || "Admin creato con successo!";
          this.$toast.success(this.successMessage);
          this.operatorName = "";
          this.emailAdmin = "";
          this.errorMessage = "";
          this.passwordAdmin = "";
          this.passwordAdminConfirm = "";
          this.fetchOperatorsSummary(); // [sc-48833] il nuovo operatore entra nel riepilogo
        } else {
          this.errorMessage =
            response.data.message || "Errore durante la creazione dell'admin"; //response diversa da 200
          this.$toast.error(this.errorMessage);
          this.successMessage = "";
        }
      } catch (error) {
        // [sc-48833] Il motivo sta in `message` (email già usata, anche di un
        // archiviato; nome troppo lungo): `details` qui è vuota e il messaggio
        // andava perso dietro al generico.
        this.errorMessage =
          error.response?.data?.message ||
          error.response?.data?.details ||
          "Errore durante la creazione dell'admin.";
        this.$toast.error(this.errorMessage);
        this.successMessage = "";
        console.error("Errore durante la creazione dell'admin: ", error);
      } finally {
        // [sc-48833] Il modale si chiude comunque: se l'API ha rifiutato, il
        // motivo va letto sul form, coi campi ancora pieni.
        this.creazioneAdminInCorso = false;
        this.showConfermaAdmin = false;
      }
    },
  },
};
</script>

<style src="@/css/AccountPage.css"></style>
